import BaseConnector from './baseConnector';

export default class AndroidConnector extends BaseConnector {
  setStatusBarColor (color) {
    if (typeof window.Android.setStatusBarColor !== 'function') {
      return;
    }
    window.Android.setStatusBarColor(color);
  }

  setNavigationBarColor (color) {
    if (typeof window.Android.setNavigationBarColor !== 'function') {
      return;
    }
    window.Android.setNavigationBarColor(color);
  }

  setModalOpened (modalOpenedData) {
    if (typeof window.Android.setModalOpened !== 'function') {
      return;
    }
    window.Android.setModalOpened(modalOpenedData);
  }

  setModalClosed () {
    if (typeof window.Android.setModalClosed !== 'function') {
      return;
    }
    window.Android.setModalClosed();
  }
}
